import dayjs from "dayjs";
import { ReceiptPb } from "../protobufs/receipt_payload";

const letters = ["A", "B", "C", "D", "E", "F", "G"];

type VatRates = { [vat: number]: VatRate; };

interface VatRate {
    vat: number;
    grossCents: number;
    netCents: number;
    taxCents: number;
    letter: string;
}

export const paymentMethodNames = [
    "Barzahlung",
    "Kartenzahlung",
    ""
]

export function grossToNet(gross: number, vat: number): number {
    const netCents = (gross / (vat + 1.0));
    return Math.round(netCents);
};

export function formatCurrency(cents: number): string {
    return (cents / 100.0).toLocaleString("de-DE", { minimumFractionDigits: 2 });
}

export function formatDateTime(unix: number): string {
    return dayjs.unix(unix).format("DD.MM.YYYY HH:mm");
}

export function calculateVatRates(receipt: ReceiptPb): VatRates {
    var vatRates: VatRates = {};
    var finalVatRates: VatRate[] = [];

    receipt.positions.forEach((p) => {
        if (p.vat in vatRates) {
            vatRates[p.vat].grossCents += p.grossValueCents;
        }
        else {
            vatRates[p.vat] = {
                grossCents: p.grossValueCents,
                vat: p.vat,
                letter: letters[Object.keys(vatRates).length],
                netCents: 0,
                taxCents: 0
            }
        }
    });

    for (let key in vatRates) {
        let value = vatRates[key];
        value.netCents = grossToNet(value.grossCents, value.vat);
        value.taxCents = value.grossCents - value.netCents;

        finalVatRates.push(value);
    }

    return vatRates
}